import { useState, useEffect } from "react";

/**
 * Custom hook to track scroll position and provide scroll-to-top functionality
 * @param threshold Optional threshold in pixels. Defaults to viewport height
 * @returns Object with showButton flag and scrollToTop function
 */
export const useScrollToTop = (
	threshold?: number
): { showButton: boolean; scrollToTop: () => void } => {
	const [showButton, setShowButton] = useState(false);

	useEffect(() => {
		const handleScroll = (): void => {
			const scrollY = window.scrollY;
			const scrollThreshold = threshold ?? window.innerHeight;
			setShowButton(scrollY > scrollThreshold);
		};

		window.addEventListener("scroll", handleScroll);
		handleScroll(); // Check initial scroll position

		return (): void => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, [threshold]);

	const scrollToTop = (): void => {
		window.scrollTo({ top: 0, behavior: "smooth" });
	};

	return { showButton, scrollToTop };
};
